import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20artistic%20gradient%20background%20with%20flowing%20organic%20waves%20of%20emerald%20green%20and%20golden%20amber%20light%2C%20soft%20glowing%20rays%20descending%20from%20above%2C%20peaceful%20spiritual%20hopeful%20atmosphere%2C%20subtle%20paper%20texture%2C%20modern%20minimalist%20design%2C%20no%20people%2C%20calming%20inspirational%20mood&width=1800&height=1000&seq=nur-hero-01&orientation=landscape"
          alt="Insani Darul Hana charity background"
          title="Persatuan Insani Darul Hana Kuching"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 text-center text-white">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-xs md:text-sm font-medium backdrop-blur-sm">
          <i className="ri-heart-3-line text-accent-300"></i>
          {t('hero.badge')}
        </span>

        <h1 className="mt-6 font-heading font-extrabold text-3xl md:text-5xl lg:text-6xl leading-tight tracking-tight">
          {t('hero.title1')}
          <span className="block text-accent-300">{t('hero.title2')}</span>
        </h1>

        <p className="mt-5 max-w-2xl mx-auto text-sm md:text-lg text-white/85 leading-relaxed">
          {t('hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#donate"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-accent-500 text-background-50 font-semibold text-sm md:text-base whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
          >
            <i className="ri-heart-3-line"></i>
            {t('hero.donate')}
          </a>
          <a
            href="#programs"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-white/15 border border-white/30 text-white font-semibold text-sm md:text-base whitespace-nowrap hover:bg-white/25 transition-colors cursor-pointer"
          >
            {t('hero.programs')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <p className="mt-8 text-xs text-white/60">{t('hero.regNo')}</p>
      </div>
    </section>
  );
}